// Home.js
import React, {useState, useEffect} from "react";
import JournalList from "./JournalList";
// import { Offcanvas, Button } from "react-bootstrap";
// import Container from "react-bootstrap/Container";
// import Form from "react-bootstrap/Form";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
import Toast from "react-bootstrap/Toast";

import JournalDetail from "./JournalDetail";
import entries from "../constants";

function Home({ isFullScreenReader }) {
    const [selectedEntry, setSelectedEntry] = React.useState(null);
    const [deviceType, setDeviceType] = useState("");
	const [showToast, setShowToast] = useState(false);

    useEffect(() => {
        // Function to detect the device type
        const detectDeviceType = () => {
            const width = window.innerWidth;

            if (width <= 768) {
                setDeviceType("mobile");
            } else if (width <= 1024) {
                setDeviceType("tablet");
            } else {
                setDeviceType("desktop");
            }
        };

        // Detect the device type on initial load
        detectDeviceType();

        // Add event listener for window resize
        window.addEventListener("resize", detectDeviceType);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("resize", detectDeviceType);
        };
    }, []);
    const fetchEntryById = (id) => {
        return entries.find((entry) => entry.id === id);
    };

    const handleSelectEntry = async (id) => {
        const entry = entries.find((entry) => entry.id === id);
		if(deviceType !== "desktop"){
			let htmlFile = '';
			try{
				htmlFile = await import(`../posts/${entry.id}.js`)
			}
			catch(error){
				setShowToast(true);
			}

			if(htmlFile && htmlFile.default){
				window.open(`/journal/${entry.id}`, '_self');
			}
		}
		else
        	setSelectedEntry(entry);
    };

    return (
        <>
		<Toast
          className={`m-1 p-3 ${deviceType !== "desktop" ? "position-fixed top-0 end-0" : ""}`}
          bg='success'
		  onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide
		  position="top-end"
        >
          <Toast.Header>
            <strong className="me-auto">Journal unavailable</strong>
          </Toast.Header>
          <Toast.Body className={'text-white'}>
            Hello, user! This is post is under publication, check after some time.
          </Toast.Body>
        </Toast>

            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "baseline",
                }}
            >
                {/* <Navbar key={false} expand={false} className="bg-body-tertiary mb-3">
          <Container fluid>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-false`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-false`}
              aria-labelledby={`offcanvasNavbarLabel-expand-false`}
              placement="start"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
                  Offcanvas
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link href="#action1">Home</Nav.Link>
                  <Nav.Link href="#action2">Link</Nav.Link>
                  <NavDropdown
                    title="Dropdown"
                    id={`offcanvasNavbarDropdown-expand-false`}
                  >
                    <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action4">
                      Another action
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action5">
                      Something else here
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className="me-2"
                    aria-label="Search"
                  />
                  <Button variant="outline-success">Search</Button>
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar> */}

                {!isFullScreenReader ? (
                    <div className="home" style={{ flexGrow: 1 }}>
                        <div className="row">
                            <div className="col-md-4">
                                <JournalList
                                    entries={entries}
                                    handleSelectEntry={handleSelectEntry}
                                />
                            </div>
                            {deviceType === "desktop" && (
                                <div className="col-md-8">
                                    <JournalDetail
                                        entry={selectedEntry}
                                        fetchEntryById={fetchEntryById}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="home" style={{ flexGrow: 1 }}>
                        <JournalDetail
                            entry={selectedEntry}
                            fetchEntryById={fetchEntryById}
                        />
                    </div>
                )}
            </div>
        </>
    );
}

export default Home;
